import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

const colors: Record<string, string> = {
  bullish: 'var(--viz-bullish)',
  bearish: 'var(--viz-bearish)',
  neutral: 'var(--text-default)',
};

export const Label = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const Marker = styled.div`
  width: 0px;
  height: 14px;
  margin-right: 8px;
  border-right: 2px solid currentColor;
`;

export const FillMarker = styled.div`
  width: 10px;
  height: 10px;
  margin-right: 8px;
  background-color: currentColor;
`;

export const BearishBias = styled(FillMarker)`
  background-color: var(--viz-bearish-soft);
`;

export const BullishBias = styled(FillMarker)`
  background-color: var(--viz-bullish-soft);
`;

export const BullishMarker = styled(Marker)`
  border-right-style: solid;
  border-right-color: var(--viz-bullish);
`;

export const BearishMarker = styled(Marker)`
  border-right-style: dashed;
  border-right-color: var(--viz-bearish);
`;

export const IndicatorWidgetWrapper = styled.section`
  ${borderRadius.r2}
  color: var(--text-default);
  height: fit-content;
  padding: 20px;
`;

export const HeadingContainer = styled.header`
  display: flex;
  align-items: center;
  white-space: pre-wrap;
  margin-bottom: 20px;
`;

export const Heading = styled.h2`
  ${typographyV2.titleMd}
`;

export const HeaderTimePeriod = styled.span`
  ${typographyV2.bodySm}
  color: var(--text-soft);
`;

export const TitleWrapper = styled.div<{
  variant?: string;
}>`
  width: 100%;
  color: ${({ variant }) =>
    variant ? colors[variant] : 'var(--text-default)'};
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  ${typographyV2.titleMd}
  width : 100%;
`;

export const Legend = styled.div`
  display: flex;
  justify-content: center;
  padding: 4px 12px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
`;
